import AbstractDataAdapter from '../AbstractDataAdapter';

class EquipmentProjectCategoryDataAdapter extends AbstractDataAdapter {
  /**
   *
   * @returns {string[]}
   */
  static get allowedFields() {
    return ['name'];
  }

  /**
   *
   * @returns {string[]}
   */
  static get requiredFields() {
    return ['name'];
  }
}

export default EquipmentProjectCategoryDataAdapter;
